import { UserUIActionType } from '../action/UserUIAction';
import { combine } from './util';

const defaultState = {
  isLoading: true,
  config: {},
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case UserUIActionType.LOADING_UI:
      return combine(state, {
        isLoading: true,
      });
    case UserUIActionType.UI_LOADED:
      return combine(state, {
        isLoading: false,
        config: action.config,
      });
    case UserUIActionType.SET_UI:
      return combine(state, {
        isLoading: false,
        config: Object.assign({}, state.config, action.config),
      });
    default:
      return state;
  }
}
